import { useEffect, useState } from "react"
import { InputAdornment, TextField } from "@mui/material"

const formatCurrency = (inputedValue) => { 
	if (!inputedValue || inputedValue === '0,0' || inputedValue === '-0,0') return '0.00'

	let formattedCurrency 	= inputedValue.toString()
	let signal				= ''

	// Verifica se foi enviado sinal negativo ou positivo
	if (formattedCurrency.includes('-')) signal = '-'
	if (formattedCurrency.includes('+')) signal = ''

	// Remove zeros à esquerda
	formattedCurrency = formattedCurrency.replace(/(^[^1-9]*)/g,'')

	// Remove tudo que não for números
	formattedCurrency = formattedCurrency.replace(/[^0-9]/g, '')

	// Separa parte inteira e parte fracionaria
	let decimalDigits = formattedCurrency.substring(formattedCurrency.length-2,formattedCurrency.length)
	let integerDigits = formattedCurrency.substring(0, formattedCurrency.length-2)

	// Formata o retorno
	if (formattedCurrency.length === 0) {
		return signal + '0,00'
	} 
	else if (decimalDigits.length < 2) {
		return signal + '0,0'+ formattedCurrency
	} 
	else if (decimalDigits.length === 2 && integerDigits === '') {
		return signal + '0,'+ formattedCurrency
	}
	else if (formattedCurrency.length < 6) {
		return signal + integerDigits +','+ decimalDigits
	}
	else {
		return signal + integerDigits.split( /(?=(?:\d{3})+(?:,|$))/g ).join( "." ) +','+ decimalDigits;
	}
}

const CurrencyField = (props) => {

	const {value, valueSetter, adornment, onChange, ...otherProps} 	= props
	const [currentValue, setCurrentValue]		= useState(0)

	useEffect(() => {
		setCurrentValue(formatCurrency(value))
	}, [value])

	const handleInput = (event) => {
		const inputedValue = event.target.value
		// Remove tudo menos numeros e separadores
		let displayFormat	= formatCurrency(inputedValue)
		let dbFormat		= displayFormat

		// Ajusta o valor para operacao em banco de dados
		if (dbFormat.match(/([0-9,]*[0-9]*\.*[0-9]{0,2})$/)) {
			dbFormat = dbFormat.replaceAll('.', '')
			dbFormat = dbFormat.replace(',', '.')
		}

		// Atualiza o valor no componente
		setCurrentValue(displayFormat)

		// Atualiza o valor do evento
		event.target.value = dbFormat

		// Sobreescreve o event nos eventos onChange/onBlur, se chamado
		if (props.onChange) props.onChange(event);
		if (props.onBlue) props.onBlur(event);
			
	}

	return (
		<TextField 
			value={currentValue}
			onChange={event => {handleInput(event)}}
			InputProps={{
				startAdornment: <InputAdornment position="start">{(adornment ? adornment : "R$")}</InputAdornment>
			}}	
			{...otherProps}
		/>
	)
}

export default CurrencyField